import React, { useState, useEffect, useMemo, useCallback } from "react";
import "bootstrap/dist/css/bootstrap.css";
import { getEventsById, getEventsCountById } from "api/EventTriggerApi";
import ContactLoader from "views/ContantLoader";
import { Container } from "reactstrap";
import Table from "../Table";
import { useSelector, useDispatch } from "react-redux";
import { setEventSignalLoading } from "ReduxStore/Slices/eventandsignalSlice";
import { exportEvents } from 'api/ExportApi'

const ListEvent = (props) => {
  const [dataApi, setDataApi] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pageIndex, setPageIndex] = useState(0);
  const [isAdmin, setIsAdmin] = useState(false);

  const { eventandsignalLoading } = useSelector(
    (state) => state.eventandsignalSetter
  );
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setEventSignalLoading(true));
  }, []);

  const fetchData = useCallback(async ({ pageSize, pageIndex }) => {
    dispatch(setEventSignalLoading(true));
    const startRow = pageSize * pageIndex;
    const endRow = startRow + pageSize;
    var url_string = window.location.href;
    var url = new URL(url_string);
    var eID = url.searchParams.get("event");
    setPageIndex(pageIndex);

    await getEventsCountById(eID)
      .then((data) => {
        setPageCount(Math.ceil(data.count / pageSize));
        setTotal(data.count);
      })

    await getEventsById(eID, pageSize, startRow)
      .then((data) => {
        var all = [];
        data.forEach((e) => {
          var x = {};
          x["name"] = "";
          if (e.eventDefinitionId) {
            x["name"] = e.eventDefinitionId.name;
          }
          x["createdAt"] = e.createdAt;
          x["email"] = "";
          x["firstName"] = "";
          x["lastName"] = "";
          x["phone"] = "";
          if (e.personId) {
            x["email"] = e.personId.email;
            x["firstName"] = e.personId.firstName;
            x["lastName"] = e.personId.lastName;
            x["phone"] = e.personId.phone;
          }
          all.push(x);
        });
        dispatch(setEventSignalLoading(false));
        setDataApi(all);
      })
  }, []);

  const data = useMemo(() => dataApi, [dataApi]);
  const columns = useMemo(
    () => [
      {
        Header: "Name",
        accessor: "name",
      },
      {
        Header: "Date",
        accessor: "createdAt",
      },
      {
        Header: "Email",
        accessor: "email",
      },
      {
        Header: "First Name",
        accessor: "firstName",
      },
      {
        Header: "Last Name",
        accessor: "lastName",
      },
      {
        Header: "Phone",
        accessor: "phone",
      },
    ],
    []
  );

  function updateRole(){
    let t = localStorage.getItem('role');
    setIsAdmin(t === 'admin');
  }
  useEffect(() => {
    updateRole()
    window.addEventListener('storage', updateRole)

  },[])

  return (
    <Container>
      <div className="page_heading">
        <h2>Events List</h2>
        <button
          className="btn btn-sm"
          style={{ color: "#114169" }}
          onClick={() =>
            props.history.push(`/admin/triggersAndEvents/allEvents`)
          }
        >{`< Back`}</button>
        {isAdmin&&<div className="export" >
          <input
            onClick={(e)=>{
              var url_string = window.location.href;
              var url = new URL(url_string);
              var eID = url.searchParams.get("event");
              exportEvents(eID)
            }}
            type="submit"
            name="Save"
            style={{
              // margin_top: "2v",
              // cursor: "pointer",
              // borderRadius: "6px",
              // padding: "0px",
              // minWidth: "90px",
              // fontSize: "13px",
              // margin: "0 12px"
            }}
            className="add__stage lg_btn primary"
            value="Export"
          />
        </div>}
        <p className="sm d-flex align-items-center">
          You have {total} Events.
          <span className="inline-label ml-auto">
            Page No. {pageIndex + 1} of {pageCount}
          </span>
        </p>
      </div>
      <div></div>
      {
        <div className="dataTableOuter">
          {
            <Table
              columns={columns}
              data={data}
              fetchData={fetchData}
              loading={eventandsignalLoading}
            ></Table>
          }
        </div>
      }
    </Container>
  );
};

export default ListEvent;
